import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import './AdminEmailPage.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const AdminEmailPage = () => {
    const { t } = useTranslation();
    const { token } = useAuth();

    const [formData, setFormData] = useState({
        fromPrefix: 'sac',
        to: '',
        subject: '',
        body: ''
    });
    const [sending, setSending] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.to || !formData.subject || !formData.body) {
            toast.error(t('fill_all_fields', 'Por favor, preencha todos os campos.'));
            return;
        }

        try {
            setSending(true);
            await axios.post(`${API_URL}/messaging/email/dispatch`, formData, {
                headers: { Authorization: `Bearer ${token}` }
            });

            toast.success(t('email_queued_success', 'Email enviado para a fila de disparo!'));
            setFormData({
                fromPrefix: 'sac',
                to: '',
                subject: '',
                body: ''
            });
        } catch (error) {
            console.error('Error dispatching email:', error);
            const msg = error.response?.data?.message || t('error_sending_email', 'Falha ao enviar email.');
            toast.error(msg);
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="admin-email-page">
            <header className="page-header">
                <h1>{t('email_dispatch_title', 'Disparo de Email')}</h1>
                <p>{t('email_dispatch_desc', 'Envie emails centralizados através da infraestrutura SQS/SES.')}</p>
            </header>

            <div className="email-composer-container">
                <form onSubmit={handleSubmit} className="email-form">
                    <div className="form-row">
                        <div className="form-group from-group">
                            <label>{t('from', 'De')}</label>
                            <div className="input-with-domain">
                                <input
                                    type="text"
                                    name="fromPrefix"
                                    value={formData.fromPrefix}
                                    onChange={handleChange}
                                    placeholder="ex: sac"
                                    required
                                />
                                <span className="domain">@novaink.com.br</span>
                            </div>
                        </div>

                        <div className="form-group to-group">
                            <label>{t('to', 'Para (Email do Destinatário)')}</label>
                            <input
                                type="email"
                                name="to"
                                value={formData.to}
                                onChange={handleChange}
                                placeholder="cliente@email.com"
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label>{t('subject', 'Assunto')}</label>
                        <input
                            type="text"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            placeholder="Ex: Atualização sobre sua conta"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>{t('message_body', 'Corpo da Mensagem')}</label>
                        <textarea
                            name="body"
                            value={formData.body}
                            onChange={handleChange}
                            rows="15"
                            placeholder="Escreva sua mensagem aqui..."
                            required
                        ></textarea>
                        <small className="hint">{t('html_hint', 'Você pode usar tags HTML básicas para formatação.')}</small>
                    </div>

                    <div className="form-actions">
                        <button
                            type="submit"
                            className={`btn-send ${sending ? 'loading' : ''}`}
                            disabled={sending}
                        >
                            {sending ? t('sending', 'Enviando...') : t('send_email_btn', 'Disparar Email')}
                        </button>
                    </div>
                </form>

                <div className="email-preview">
                    <h3>{t('preview', 'Prévia')}</h3>
                    <div className="preview-card">
                        <div className="preview-header">
                            <p><strong>{t('from', 'De')}:</strong> {formData.fromPrefix}@novaink.com.br</p>
                            <p><strong>{t('to', 'Para')}:</strong> {formData.to || '...'}</p>
                            <p><strong>{t('subject', 'Assunto')}:</strong> {formData.subject || '...'}</p>
                        </div>
                        <div className="preview-body" dangerouslySetInnerHTML={{ __html: formData.body || t('body_placeholder', 'Conteúdo do email aparecerá aqui...') }}>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminEmailPage;
